import React from 'react';
import { RotateLoader } from 'react-spinners';

const override = {
  display: 'block',
  margin: '0 auto',
};

const Spinner = ({ loading }: { loading: boolean }) => {
  if (!loading) return null;

  const corPrincipal = getComputedStyle(document.documentElement).getPropertyValue('--cor-principal').trim();

  return (
    <div style={overlayStyle}>
      <div style={contentStyle}>
        <RotateLoader color={corPrincipal || '#ffffff'} loading={loading} cssOverride={override} />
        <p style={textStyle}>Carregando...</p>
      </div>
    </div>
  );
};

export default Spinner;

// Estilos inline para a sobreposição e centralização
const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  color: '#fff',
};

const textStyle: React.CSSProperties = {
  marginTop: '16px',
  fontSize: '18px',
  fontWeight: 'bold',
};
